import { memo } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { SelectColumnCellProps } from "../types";

function SelectColumnCell({
  creatorId,
  isSelected,
  panelSelected,
  onToggleSelected,
}: SelectColumnCellProps) {
  return (
    <div className="flex items-center justify-center">
      <Checkbox
        checked={isSelected}
        onCheckedChange={(value) => onToggleSelected(!!value)}
        aria-label="Select row"
        aria-describedby={undefined}
        data-creator-id={creatorId}
        className={`size-4.25 ${
          panelSelected ? "ring-3 ring-primary/20 border-primary" : ""
        }`}
      />
    </div>
  );
}

export default memo(SelectColumnCell);
